import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const ROLE_LEVEL = { viewer: 1, editor: 2, manager: 3, admin: 4 };
export const ROLE_LABELS = {
  viewer: "Visualizador",
  editor: "Editor",
  manager: "Gestor",
  admin: "Administrador",
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(null);
  };

  const level = user ? ROLE_LEVEL[user.role] || 1 : 0;

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        refresh: fetchMe,
        canEdit: level >= 2,
        canManage: level >= 3,
        isAdmin: level >= 4,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
